var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"moon-wrapper"},[_c('div',{attrs:{"id":"moon-pie-container"}}),_vm._v(" "),_c('div',{staticClass:"moon"}),_vm._v(" "),_c('div',{staticClass:"shadow"}),_vm._v(" "),_c('v-rocket')],1)}
var staticRenderFns = []

export { render, staticRenderFns }